<template>
  <div class="wrapper sign-up-page">
    <div class="w-100">
      <register-header :show-button="false" logoType="white"></register-header>
      <section class="content">
        <div class="container">
          <div class="header-title">
            <h1>Sign up for FLIP Africa</h1>
          </div>
          <div class="bgcontent sign-up-container">
            <form id="regForm" class="sign-up-form" method="post" autocomplete="off">
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label>First Name (*)</label>
                    <input
                      v-model="firstName"
                      class="form-control custom-input"
                      autocomplete="off"
                      placeholder="Enter First Name"
                      oninput="this.className = 'form-control custom-input'"
                      v-validate="'required'"
                      name="name"
                      data-vv-scope="inforUser"
                      @keypress="nameNotAllowNumber(e)"
                      required
                    />
                    <span class="field-error">{{ errors.first('inforUser.name') }}</span>
                  </div>
                </div>
                <div class="col-12 mt-2">
                  <div class="form-group">
                    <label>Last Name/Family Name (*)</label>
                    <input
                      v-model="lastName"
                      v-validate="'required'"
                      autocomplete="off"
                      class="form-control custom-input"
                      placeholder="Enter Last Name/Family Name"
                      oninput="this.className = 'form-control custom-input'"
                      name="surname"
                      data-vv-scope="inforUser"
                      data-vv-as="surname"
                      @keypress="nameNotAllowNumber(e)"
                      required
                    />
                    <span class="field-error">{{ errors.first('inforUser.surname') }}</span>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <div class="form-group">
                    <label for="Email">Email Address (*)</label>
                    <input
                      v-model.trim="email"
                      @change="onChangeEmail($event)"
                      @keydown="checkEmailExists"
                      autocomplete="false"
                      readonly
                      onfocus="this.removeAttribute('readonly');"
                      v-validate="'required|email'"
                      type="text"
                      name="email"
                      class="form-control custom-input"
                      id="email"
                      aria-describedby="emailHelp"
                      placeholder="E.g abc@gmail.com"
                      :class="{'is-danger': errors.has('email')}"
                      ref="email"
                      data-vv-scope="inforUser"
                      required
                    />
                    <span
                      v-show="errors.has('inforUser.email')"
                      class="help is-danger show-error"
                    >{{ errors.first('inforUser.email') }}</span>
                    <span
                      v-show="errorData.email_conflictMessage"
                      class="show-error"
                    >{{ errorData.email_conflictMessage }}</span>
                    <span
                      v-show="errorData.emailMessage"
                      class="show-error"
                    >{{ errorData.emailMessage }}</span>
                    <span
                      v-show="isExistsEmail"
                      class="show-error"
                    >{{ errorData.emailExistsMessage }}</span>
                  </div>
                </div>
                   <div class="col-6">
                  <div class="form-group">
                    <label for="phone">Phone Number (*)</label>
                    <vue-tel-input
                      v-model.trim="phoneNumber"
                      wrapperClasses="form-control"
                      @input="onInput"
                      placeholder="071 2345 678"
                      :required="true"
                    ></vue-tel-input>
                    <span v-show="!phoneNumberValid" class="field-error">{{
                      phoneNumberErrorMessage
                    }}</span>
                    <span v-show="isExistsPhone" class="field-error">{{
                      errorData.phoneExistsMessage
                    }}</span>
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <label>Date oF Birth</label>
                    <date-picker
                      type="date"
                      value-type="format"
                      input-class="form-control style-chooser select-no-width"
                      placeholder="MM-DD-YYYY"
                      format="MM-DD-YYYY" :disabled-date="notAfterToday" v-on:change="setBackPage(4, false)"
                      v-model="date_of_birth"
                    ></date-picker>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <div class="form-group">
                    <label>Create Password (*)</label>
                    <div class="input-group">
                      <input
                        v-model="password"
                        @click="onChangePassword($event)"
                        @change="checkPassWordTrue"
                        v-validate="'required|min:8'"
                        class="form-control"
                        autocomplete="false"
                        readonly
                        onfocus="this.removeAttribute('readonly');"
                        oninput="this.className = 'form-control'"
                        name="password"
                        type="password"
                        :class="{'is-danger': errors.has('password')}"
                        ref="password"
                        data-vv-as="Password"
                        data-vv-scope="inforUser"
                        placeholder="Enter password"
                      />
                      <div class="input-group-append">
                        <div class="input-group-text">
                          <i class="far fa-eye" ref="togglePassword"></i>
                        </div>
                      </div>
                    </div>
                    <span
                      v-show="errors.has('inforUser.password')"
                      class="help is-danger show-error"
                    >{{ errors.first('inforUser.password') }}</span>
                    <span
                      v-show="errorData.password1Message"
                      class="show-error"
                    >{{ errorData.password1Message }}</span>
                  </div>
                </div>
                <div class="col-12 mt-2">
                  <div class="form-group">
                    <label>Confirm Password (*)</label>
                    <div class="input-group">
                      <input
                        class="form-control"
                        autocomplete="false"
                        readonly
                        onfocus="this.removeAttribute('readonly');"
                        oninput="this.className = 'form-control'"
                        name="c-password"
                        type="password"
                        v-validate="'required|confirmed:password'"
                        :class="{'is-danger': errors.has('password_confirmation')}"
                        data-vv-as="Confirm Password"
                        data-vv-scope="inforUser"
                        ref="confirmPassword"
                        placeholder="Enter password"
                      />
                      <div class="input-group-append">
                        <div class="input-group-text">
                          <i class="far fa-eye" ref="toggleConfirmPassword"></i>
                        </div>
                      </div>
                    </div>
                    <span
                      v-show="errors.has('inforUser.c-password')"
                      class="help is-danger show-error"
                    >{{ errors.first('inforUser.c-password') }}</span>
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12 checkbox-fl">
                  <div class="form-group mb-0">
                    <label class="checkbox-button">
                      <p class="text-checkbox mb-0">
                        Agree to
                        <a @click="openTermAndConditionsModal($event)">Terms and Conditions</a>
                      </p>
                      <input
                        type="checkbox"
                        v-validate="'required'"
                        name="terms-and-conditions"
                        data-vv-as="Terms and Conditions"
                        data-vv-scope="inforUser"
                      />
                      <span class="checkbox-checkmark"></span>
                    </label>
                    <span
                      v-show="errors.has('inforUser.terms-and-conditions')"
                      class="help is-danger show-error"
                    >{{ errors.first('inforUser.terms-and-conditions') }}</span>
                  </div>
                </div>
                <div class="col-12 checkbox-fl">
                  <div class="form-group mb-0">
                    <label class="checkbox-button">
                      <p
                        class="text-checkbox mb-0"
                      >Receive updates regarding your matches and other relevant announcements</p>
                      <input
                        type="checkbox"
                        v-model="isReceiveEmail"
                      />
                      <span class="checkbox-checkmark"></span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-12 text-center">
                  <button type="button" class="btn btn-primary btn-signup" @click="signUpUser">SIGN UP</button>
                </div>
              </div>
            </form>
          </div>
          <div class="row mb-5">
            <div class="col-12">
              <p class="text-p-regular text-center">
                Have an account already?
                <router-link :to="{path: '/login'}">Sign in</router-link>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
    <TermsAndConditionsModal ref="termsAndConditionsModal"></TermsAndConditionsModal>
  </div>
</template>
<script>
import RegisterHeader from '@/components/RegisterHeader'
import FacebookButton from '@/components/login/FacebookButton'
import GoogleButton from '@/components/login/GoogleButton'
import TermsAndConditionsModal from '@/components/signup/TermsAndConditionsModal'
import {
  SIGNUP_TAB_INDEX,
  EDIT_PERSONAL_INFORMATION_INVALID_PHONE_NUMBER,
  EMAIL_EXISTS_MESSAGE,
  PHONE_EXISTS_MESSAGE,
  SIGN_UP_SUCCESS,
  POST_JOB_SUCCESS
} from '@/utils/constants'
import _, { assign } from 'lodash'
import { parseErrorMessage } from '@/utils/utils'
export default {
  components: {
    RegisterHeader,
    FacebookButton,
    GoogleButton,
    TermsAndConditionsModal
  },
  data: () => {
    return {
      firstName: '',
      lastName: '',
      phoneNumber: '',
      phoneNumberValid: false,
      phoneNumberErrorMessage: '',
      email: '',
      c_email: '',
      password: '',
      date_of_birth: '',
      isReceiveEmail: false,
      tabIndex: 0,
      showUserNameTab: true,
      showPasswordTab: false,
      showTermsTab: false,
      // showUploadPhotoVideoTab: false,
      showVerifyEmail: false,
      name: '',
      attemptSubmit: false,
      user: {},
      confirmCode: '',
      sentEmailConfirmCode: false,
      showButtonHeader: true,
      showTextResend: SIGNUP_TAB_INDEX.SHOW_RESEND_TEXT,
      showTabIndex: SIGNUP_TAB_INDEX.SHOW_TAB_INDEX,
      showBackButton: SIGNUP_TAB_INDEX.SHOW_BACK_BUTTON,
      errorData: {
        emailMessage: '',
        email_conflictMessage: '',
        password1Message: '',
        proof_of_identification_urlMessage: '',
        emailExistsMessage: '',
        phoneExistsMessage: ''
      },
      showErrorCode: '',
      isExistsEmail: false,
      isExistsPhone: false
    }
  },
  created: function () {
    this.login()
  },
  mounted: async function () {
    this.addEyeTogglePassword('togglePassword', 'password')
    this.addEyeTogglePassword('toggleConfirmPassword', 'confirmPassword')
  },
  methods: {
    notAfterToday(date) {
      return date > new Date(new Date().setHours(0, 0, 0, 0))
    },
    login () {
      this.$gtag.event('Sign up', { method: 'Google' })
      // eslint-disable-next-line no-undef
      fbq('trackCustom', 'Sign up')
    },
    onInput(formattedNumber, { number, valid, country }) {
      this.phoneNumber = number.international
      this.phoneNumberValid = valid
      if (!formattedNumber) {
        this.phoneNumberValid = true
      }
      if (!this.phoneNumberValid) {
        this.phoneNumberErrorMessage = EDIT_PERSONAL_INFORMATION_INVALID_PHONE_NUMBER
      } else {
        this.phoneNumberErrorMessage = ''
      }
      this.checkPhoneExists()
    },
    checkPassWordTrue: function () {
      let regex = '^((?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&]))(?=.{8,})'
      if (
        !this.password.match(regex) &&
        this.password !== '' &&
        this.password.length >= 8
      ) {
        this.errorData.password1Message =
          'Password includes at least: numeric character,special character and letters'
      } else {
        this.errorData.password1Message = ''
      }
    },
    nameNotAllowNumber: function (evt) {
      evt = evt || window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        return true
      } else {
        evt.preventDefault()
      }
    },
    signUpUser: async function () {
      let valid = await this.$validator.validateAll('inforUser')
      let dateArray = this.date_of_birth.split('-')
      let formattedDate = `${dateArray[2]}-${dateArray[0]}-${dateArray[1]}`
      if (
        valid &&
        this.phoneNumberValid &&
        !this.isExistsEmail &&
        !this.isExistsPhone
      ) {
        let loader = this.$loading.show()
        try {
          let payload = {
            params: {
              email: this.email,
              username: this.email,
              password1: this.password,
              password2: this.password,
              phone_number: this.phoneNumber.replace(/\s/g, ''),
              first_name: this.firstName,
              last_name: this.lastName,
              date_of_birth: formattedDate,
              is_receive_email: this.isReceiveEmail
            }
          }
          payload.params = assign({}, payload.params)
          let responseUser = await this.$store.dispatch('registerUser', payload)
          this.$snotify.success(SIGN_UP_SUCCESS, 'Success')
          let payloadPostJob = sessionStorage.getItem('data_post_job')
          if (payloadPostJob) {
            payloadPostJob = JSON.parse(payloadPostJob)
            delete payloadPostJob.params.employer
            payloadPostJob.params.user_id = responseUser.data.user_id
            await this.$store.dispatch('postCreateJob', payloadPostJob)
            sessionStorage.removeItem('data_post_job')
            this.$snotify.success(POST_JOB_SUCCESS, 'Success')
          }
          loader.hide()
          this.$router.push('/')
        } catch (error) {
          loader.hide()
          this.$snotify.error(parseErrorMessage(error), 'Error')
        }
      }
    },
    checkEmailExists: _.debounce(function (e) {
      const payload = {
        query: {
          email: this.email
        }
      }
      this.$store
        .dispatch('checkEmailOrPhoneExists', payload)
        .then((response) => {
          if (response.data.exists) {
            this.isExistsEmail = true
            this.errorData.emailExistsMessage = EMAIL_EXISTS_MESSAGE
          } else {
            this.isExistsEmail = false
            this.errorData.emailExistsMessage = ''
          }
        })
        .catch((e) => {
          this.isExistsEmail = false
          this.errorData.emailExistsMessage = ''
        })
    }, 500),
    checkPhoneExists: _.debounce(function (e) {
      const payload = {
        query: {
          phone: this.phoneNumber
        }
      }
      this.$store
        .dispatch('checkEmailOrPhoneExists', payload)
        .then((response) => {
          if (response.data.exists) {
            this.isExistsPhone = true
            this.errorData.phoneExistsMessage = PHONE_EXISTS_MESSAGE
          } else {
            this.isExistsPhone = false
            this.errorData.phoneExistsMessage = ''
          }
        })
        .catch((e) => {
          this.isExistsPhone = false
          this.errorData.phoneExistsMessage = ''
        })
    }, 500),
    onChangeEmail: function (event) {
      this.sentEmailConfirmCode = false
      this.errorData.email_conflictMessage = ''
      this.errorData.emailMessage = ''
    },
    onChangePassword: function (event) {
      this.errorData.password1Message = ''
    },
    openTermAndConditionsModal: function (event) {
      event.preventDefault()
      this.$refs.termsAndConditionsModal.showModal()
    },
    addEyeTogglePassword: function (elementEye, element) {
      const togglePassword = this.$refs[elementEye]
      const passwordEle = this.$refs[element]
      togglePassword.addEventListener('click', function (e) {
        const type =
          passwordEle.getAttribute('type') === 'password' ? 'text' : 'password'
        passwordEle.setAttribute('type', type)
        this.classList.toggle('fa-eye-slash')
      })
    },
    goBack: function() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
    }
  }
}
</script>
<style scoped>
.field-error {
  color: red;
}
.show-error {
  color: red;
  font-size: 13px;
}
.mx-datepicker {
    position: relative;
    display: inline-block;
    width:  100%;
}
</style>



// WEBPACK FOOTER //
// src/layout/sign-up.vue